import { CreateEntity, IEntity, UpdateEntity } from "@/types/breeze/Entity";
import { Workflow } from "@/types/breeze/Workflow";
import { BaseService } from "../BaseService";

export class EntityService extends BaseService {
  public async getAll(includeSystem: boolean = false): Promise<IEntity[]> {
    const qs = includeSystem
      ? "?includeJunctions=true&includeSystem=true"
      : "?includeJunctions=true";
    return this.getRequest(`/entities${qs}`);
  }

  public async getById(id: number): Promise<IEntity> {
    return this.getRequest(`/entities/id/${id}`);
  }

  public async getByName(name: string, includeSystem: boolean = false): Promise<IEntity> {
    const qs = includeSystem ? "?includeSystem=true" : "";
    return this.getRequest(`/entities/${name}${qs}`);
  }

  public async getWorkflows(name: string): Promise<Workflow[]> {
    return this.getRequest(`/entities/${name}/workflows`);
  }

  public async createEntity(entity: CreateEntity): Promise<IEntity> {
    return this.postRequest("/entities", entity, "Entity created");
  }

  public async updateEntity(
    name: string,
    data: UpdateEntity,
  ): Promise<IEntity> {
    return this.putRequest(`/entities/${name}`, data, "Entity updated");
  }

  public async deleteEntity(name: string): Promise<void> {
    return this.deleteRequest(`/entities/${name}`, "Entity deleted");
  }

  public async reorderEntities(
    updates: { entity_id: number; sort_order: number }[],
  ): Promise<void> {
    return this.putRequest("/entities/reorder", updates, "", true, true);
  }
}

export const entityService = new EntityService();
